import React, { useState, forwardRef } from 'react';
import styles from './GlobalDatepicker.module.css';

interface GlobalDatepickerProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
  error?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const GlobalDatepicker = forwardRef<HTMLInputElement, GlobalDatepickerProps>(
  ({ label, error, className, value, onChange, ...props }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    const hasValue = value !== undefined && value !== null && String(value).length > 0;

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(true);
      props.onFocus?.(e);
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(false);
      props.onBlur?.(e);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e);
      }
    };

    return (
      <div className={`${styles.inputContainer} ${className || ''}`}>
        <div className={styles.inputWrapper}>
          <input
            {...props}
            ref={ref}
            type="date"
            value={value}
            className={`${styles.input} ${error ? styles.error : ''} ${isFocused ? styles.focused : ''} ${hasValue ? styles.hasValue : ''}`}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            placeholder=" "
          />
          <label className={styles.label}>{label}</label>
        </div>
        {error && <span className={styles.errorMessage}>{error}</span>}
      </div>
    );
  }
);

GlobalDatepicker.displayName = 'GlobalDatepicker';
